var exports = {
  "s": "CommentDividerContainer__bKljrN",
  "uI": "CommentDividerLeftLine__OPKiZD",
  "GJ": "CommentDividerLoadingSkeleton__hJwzq2",
  "NW": "CommentDividerRightLine__BCjucN",
  "Uo": "paddingBottomDefault__mJPS_G",
  "ct": "paddingBottomLarge__rNY6MY",
};

module.exports = exports;
